import { formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AppLocaleService } from '@core/services/app-locale.service';

@Component({
	selector: 'cass-display-dates-list',
	templateUrl: './display-dates-list.component.html',
	styleUrls: ['./display-dates-list.component.css']
})
export class DisplayDatesListComponent implements OnInit {

	// @Input()
	// Dates: Date[] = [];


	@Input()
	get dates(): readonly Date[] | undefined {
		return this._dates;
	}
	set dates(dates: readonly Date[] | undefined) {
		this._dates = dates;
	}
	private _dates: readonly Date[] | undefined;

	constructor(private _appLocaleService: AppLocaleService) { }

	ngOnInit(): void {
	}

	toLocalFormat(d: Date) {
		return formatDate(d, this._appLocaleService.dateFormat, this._appLocaleService.currentOrDefaultLocaleId);
	}

}
